/* eslint-disable react-hooks/exhaustive-deps */
import React, { useMemo, useState } from 'react'
import { useQuery } from 'react-query'
import { useRouter } from 'next/router'

import { useCategories } from '@hooks/useCategories'
import { useCharacterAction } from '@hooks/character/useCharacterAction'
import { OptionFormProps, OptionFormAcceptProps } from './interface'

export function withOptionForm(Component: React.FC<OptionFormProps>) {
  function WithOptionForm({
    initialValues,
    handleSearch,
  }: OptionFormAcceptProps) {
    const characterClient = useCharacterAction()
    const router = useRouter()
    const [showOption, setShowOption] = useState(
      router.query.advanceSearch === 'true'
    )

    const { categories: categoryOptions, isLoading: isCategoryLoading } =
      useCategories()
    const { data: characterRoles = [], isLoading: isCharacterLoading } =
      useQuery('character-role-options', () =>
        characterClient.getCharacterRoles()
      )

    function toggleOption() {
      setShowOption(prev => !prev)

      router.replace(
        {
          pathname: router.pathname,
          query: {
            text: initialValues.searchText,
            roleId: initialValues.characterRoleId,
            advanceSearch: !showOption,
          },
        },
        undefined,
        { scroll: false }
      )
    }

    const characterRoleOptions = useMemo(() => {
      return [
        { value: 0, text: 'ทั้งหมด' },
        ...characterRoles.map(({ value, label }) => ({
          value,
          text: label,
        })),
      ]
    }, [characterRoles])

    if (
      isCategoryLoading ||
      isCharacterLoading ||
      categoryOptions.length === 0 ||
      characterRoleOptions.length === 0
    ) {
      return null
    }

    const componentProps = {
      initialValues,
      showOption,
      categoryOptions,
      characterRoleOptions,
      handleSearch,
      toggleOption,
    }
    return <Component {...componentProps} />
  }
  return WithOptionForm
}
